import { render } from "./PublicCVPreview.vue?vue&type=template&id=65e6d56c"
import script from "./PublicCVPreview.vue?vue&type=script&lang=js"
export * from "./PublicCVPreview.vue?vue&type=script&lang=js"

import "./PublicCVPreview.vue?vue&type=style&index=0&id=65e6d56c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__